import * as React from 'react'

import { Dialog, DialogContent } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface Props {
	onClose: () => void
	/**
	 * Note: This prop is kept for API compatibility.
	 * In this implementation, it is called immediately on close,
	 * not after the exit animation is complete.
	 */
	onExited?: () => void
	isOpen: boolean
	children: React.ReactNode
	className?: string
}

const AstaModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onExited,
	children,
	className,
}) => {
	const handleOpenChange = (open: boolean) => {
		// `onOpenChange` fires when the dialog's open state is requested to change.
		// We only trigger our callbacks when it's closing.
		if (!open) {
			onClose()
			onExited?.()
		}
	}

	return (
		<Dialog open={isOpen} onOpenChange={handleOpenChange}>
			<DialogContent className={cn('text-foreground', className)}>
				{children}
			</DialogContent>
		</Dialog>
	)
}

export default AstaModal
